// Module Name
export const name = 'promotions';

export const typePromotions = {
    GET_PROMOTIONS: `${name}/GET_PROMOTIONS`,
    CREATE_PROMOTION: `${name}/CREATE_PROMOTION`,
};
